if (!window.__opQuickAdd) {
  window.__opQuickAdd = true;

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-op-add]') : null;
    if (!button || button.disabled) return;
    event.preventDefault();

    const variantId = Number(button.dataset.variant);
    if (!variantId) return;

    const original = button.textContent;
    const restore = (delay) =>
      setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, delay);

    button.disabled = true;
    button.textContent = button.dataset.addingLabel || 'Agregando…';

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || data.status) throw new Error(data.description || 'No se pudo agregar');
        button.textContent = button.dataset.doneLabel || 'Agregado ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        restore(1800);
      })
      .catch(() => {
        button.textContent = button.dataset.errorLabel || 'No se pudo agregar';
        restore(2500);
      });
  });
}
